import { render, staticRenderFns } from "./PageTwo.vue?vue&type=template&id=80504bb6&scoped=true&"
import script from "./PageTwo.vue?vue&type=script&lang=js&"
export * from "./PageTwo.vue?vue&type=script&lang=js&"
import style0 from "./PageTwo.vue?vue&type=style&index=0&id=80504bb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80504bb6",
  null
  
)

export default component.exports